import React, { useState, useEffect } from 'react';
import { Button, TextField, Grid } from '@mui/material';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, push, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';

import fc from '../firebaseConfig';

const db = getDatabase(fc);

const formatDateTime = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
};

const AddToDatabase = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('LOGGED_IN');
    if (!isLoggedIn) {
      navigate('/');
    }
  }, [navigate]);

  const handleSave = async () => {
    if (!title || !description) {
      alert('Title and description are required.');
      return;
    }

    const now = new Date();
    
    now.setHours(now.getHours() + 2);
    
    const currentDateTime = formatDateTime(now);

    const data = {
      title,
      description,
      date: currentDateTime
    };

    try {
      const dataRef = ref(db, 'data');
      const newItemRef = push(dataRef);
      await set(newItemRef, data);
      alert('Data saved successfully');
      setTitle('');
      setDescription('');
    } catch (error) {
      console.error('Error saving data: ', error);
      alert('Error saving data');
    }
  };

  return (
    <div>
      <Navbar/>
      <h2 className='header' style={{ marginTop: '5rem' }}>Add To Database</h2>
      <Grid container spacing={2} direction="column" alignItems="center">
        <Grid item xs={12}>
          <TextField
            label="Title"
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            margin="normal"
            sx={{
              '& .MuiOutlinedInput-root': {
              '& fieldset': {
                  borderColor: 'black',
              }
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Description"
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            margin="normal"
            sx={{
              '& .MuiOutlinedInput-root': {
              '& fieldset': {
                  borderColor: 'black',
              }
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            style={{ marginTop: '16px' }}
          >
            DODAJ DO BAZY DANYCH
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddToDatabase;
